import { render } from "./clinic-archived-list.vue?vue&type=template&id=68138e3e&scoped=true"
import script from "./clinic-archived-list.vue?vue&type=script&lang=js"
export * from "./clinic-archived-list.vue?vue&type=script&lang=js"

import "./clinic-archived-list.vue?vue&type=style&index=0&id=68138e3e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68138e3e"]])

export default __exports__